import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {BehaviorSubject, Observable} from 'rxjs';
import {DcpAuthService} from '../../auth/services/dcp-auth.service';
import {map} from 'rxjs/operators';
import {AuthStorageService, AuthToken} from '@spartacus/core';
import {isPlatformBrowser} from '@angular/common';

const LOGIN_TRIED: string = 'loginTried';

@Injectable({
  providedIn: 'root',
})
export class DynamicAuthGuard {
  protected loginErrorSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    protected authService: DcpAuthService,
    protected authStorageService: AuthStorageService,
    @Inject(PLATFORM_ID) public platformId: string
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authStorageService.getToken().pipe(
      map((token: AuthToken) => {
        if (isPlatformBrowser(this.platformId) && window.localStorage) {
          const loginRequired: string = route.queryParamMap.get('loginRequired');
          this.handleLoginConditions(token.access_token, loginRequired === 'true', state);
        }
        return true;
      })
    );
  }

  hasLoginError$(): Observable<boolean> {
    return this.loginErrorSubject.asObservable();
  }

  protected setLoginTriedFlag(): void {
    window.localStorage.setItem(LOGIN_TRIED, 'true');
  }

  protected removeLoginTriedFlag(): void {
    window.localStorage.removeItem(LOGIN_TRIED);
  }

  protected getLoginTriedFlag(): string {
    return window.localStorage.getItem(LOGIN_TRIED);
  }

  protected handleLoginConditions(accessToken: string, loginRequired: boolean, state: RouterStateSnapshot): boolean {
    if (!accessToken && loginRequired) {
      if (this.getLoginTriedFlag() !== 'true') {
        this.setLoginTriedFlag();
        this.loginErrorSubject.next(false);
        this.authService.login(state.url);
      } else {
        this.removeLoginTriedFlag();
        this.loginErrorSubject.next(true);
      }
      return true;
    } else {
      this.removeLoginTriedFlag();
      this.loginErrorSubject.next(false);
      return false;
    }
  }
}
